import ue from "jwt-decode";
import { createMachine as P, send as T, assign as E, interpret as b } from "xstate";
import L from "js-cookie";
import le from "fetch-ponyfill";
const O = "nhostRefreshToken", N = "nhostRefreshTokenId", R = "nhostRefreshTokenExpiresAt", de = 3, fe = 60, H = 5, Z = 0, J = 1, k = 10, C = 20;
class U extends Error {
  constructor(e) {
    super(e.message), Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), e instanceof Error ? (this.name = e.name, this.error = {
      error: e.name,
      status: J,
      message: e.message
    }) : (this.name = e.error, this.error = e);
  }
}
const A = {
  status: k,
  error: "invalid-email",
  message: "Email is incorrectly formatted"
}, he = {
  status: k,
  error: "invalid-mfa-type",
  message: "MFA type is invalid"
}, me = {
  status: k,
  error: "invalid-mfa-code",
  message: "MFA code is invalid"
}, $ = {
  status: k,
  error: "invalid-password",
  message: "Password is incorrectly formatted"
}, Y = {
  status: k,
  error: "invalid-phone-number",
  message: "Phone number is incorrectly formatted"
}, Ee = {
  status: k,
  error: "invalid-mfa-ticket",
  message: "MFA ticket is invalid"
}, ge = {
  status: k,
  error: "no-mfa-ticket",
  message: "No MFA ticket has been provided"
}, Te = {
  status: k,
  error: "no-refresh-token",
  message: "No refresh token has been provided"
}, pe = {
  status: C,
  error: "refresher-already-running",
  message: "The token refresher is already running. You must wait until is has finished before submitting a new token."
}, y = {
  status: C,
  error: "already-signed-in",
  message: "User is already signed in"
}, we = {
  status: C,
  error: "unauthenticated-user",
  message: "User is not authenticated"
}, or = {
  status: C,
  error: "user-not-anonymous",
  message: "User is not anonymous"
}, ke = {
  status: C,
  error: "unverified-user",
  message: "Email needs verification"
}, ye = {
  status: k,
  error: "invalid-refresh-token",
  message: "Invalid or expired refresh token"
}, Se = {
  status: J,
  error: "invalid-sign-in-method",
  message: "Invalid sign-in method"
}, G = {
  user: null,
  mfa: null,
  accessToken: {
    value: null,
    expiresAt: null,
    expiresInSeconds: 15
  },
  refreshTimer: {
    startedAt: null,
    attempts: 0,
    lastAttempt: null
  },
  refreshToken: {
    value: null
  },
  importTokenAttempts: 0,
  errors: {}
};
function ve(t) {
  return new TextEncoder().encode(t);
}
function _(t) {
  const e = new Uint8Array(t);
  let n = "";
  for (const s of e)
    n += String.fromCharCode(s);
  return btoa(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function j(t) {
  const e = t.replace(/-/g, "+").replace(/_/g, "/"), n = (4 - e.length % 4) % 4, r = e.padEnd(e.length + n, "="), s = atob(r), i = new ArrayBuffer(s.length), c = new Uint8Array(i);
  for (let d = 0; d < s.length; d++)
    c[d] = s.charCodeAt(d);
  return i;
}
function ee() {
  return (window == null ? void 0 : window.PublicKeyCredential) !== void 0 && typeof window.PublicKeyCredential == "function";
}
function re(t) {
  const { id: e } = t;
  return {
    ...t,
    id: j(e),
    transports: t.transports
  };
}
function ne(t) {
  return t === "localhost" || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(t);
}
class g extends Error {
  constructor(e, n = "WebAuthnError") {
    super(e), this.name = n;
  }
}
function Ae({ error: t, options: e }) {
  var n, r;
  const { publicKey: s } = e;
  if (!s)
    throw Error("options was missing required publicKey property");
  if (t.name === "AbortError") {
    if (e.signal === new AbortController().signal)
      return new g("Registration ceremony was sent an abort signal", "AbortError");
  } else if (t.name === "ConstraintError") {
    if (((n = s.authenticatorSelection) === null || n === void 0 ? void 0 : n.requireResidentKey) === !0)
      return new g("Discoverable credentials were required but no available authenticator supported it", "ConstraintError");
    if (((r = s.authenticatorSelection) === null || r === void 0 ? void 0 : r.userVerification) === "required")
      return new g("User verification was required but no available authenticator supported it", "ConstraintError");
  } else {
    if (t.name === "InvalidStateError")
      return new g("The authenticator was previously registered", "InvalidStateError");
    if (t.name === "NotAllowedError")
      return new g("User clicked cancel, or the registration ceremony timed out", "NotAllowedError");
    if (t.name === "NotSupportedError")
      return s.pubKeyCredParams.filter((c) => c.type === "public-key").length === 0 ? new g('No entry in pubKeyCredParams was of type "public-key"', "NotSupportedError") : new g("No available authenticator supported any of the specified pubKeyCredParams algorithms", "NotSupportedError");
    if (t.name === "SecurityError") {
      const i = window.location.hostname;
      if (ne(i)) {
        if (s.rp.id !== i)
          return new g(`The RP ID "${s.rp.id}" is invalid for this domain`, "SecurityError");
      } else
        return new g(`${window.location.hostname} is an invalid domain`, "SecurityError");
    } else if (t.name === "TypeError") {
      if (s.user.id.byteLength < 1 || s.user.id.byteLength > 64)
        return new g("User ID was not between 1 and 64 characters", "TypeError");
    } else if (t.name === "UnknownError")
      return new g("The authenticator was unable to process the specified options, or could not create a new credential", "UnknownError");
  }
  return t;
}
class Ie {
  createNewAbortSignal() {
    return this.controller && this.controller.abort(), this.controller = new AbortController(), this.controller.signal;
  }
  reset() {
    this.controller = void 0;
  }
}
const K = new Ie();
async function te(t) {
  if (!ee())
    throw new Error("WebAuthn is not supported in this browser");
  const n = { publicKey: {
    ...t,
    challenge: j(t.challenge),
    user: {
      ...t.user,
      id: ve(t.user.id)
    },
    excludeCredentials: t.excludeCredentials.map(re)
  } };
  n.signal = K.createNewAbortSignal();
  let r;
  try {
    r = await navigator.credentials.create(n);
  } catch (h) {
    throw Ae({ error: h, options: n });
  } finally {
    K.reset();
  }
  if (!r)
    throw new Error("Registration was not completed");
  const { id: s, rawId: i, response: c, type: d } = r, f = {
    id: s,
    rawId: _(i),
    response: {
      attestationObject: _(c.attestationObject),
      clientDataJSON: _(c.clientDataJSON)
    },
    type: d,
    clientExtensionResults: r.getClientExtensionResults(),
    authenticatorAttachment: r.authenticatorAttachment
  };
  return typeof c.getTransports == "function" && (f.transports = c.getTransports()), f;
}
function _e(t) {
  return new TextDecoder("utf-8").decode(t);
}
async function Re() {
  if (navigator.credentials.conditionalMediationSupported)
    return !0;
  const t = window.PublicKeyCredential;
  return t.isConditionalMediationAvailable !== void 0 && t.isConditionalMediationAvailable();
}
function Pe({ error: t, options: e }) {
  var n;
  const { publicKey: r } = e;
  if (!r)
    throw Error("options was missing required publicKey property");
  if (t.name === "AbortError") {
    if (e.signal === new AbortController().signal)
      return new g("Authentication ceremony was sent an abort signal", "AbortError");
  } else {
    if (t.name === "NotAllowedError")
      return !((n = r.allowCredentials) === null || n === void 0) && n.length ? new g("No available authenticator recognized any of the allowed credentials", "NotAllowedError") : new g("User clicked cancel, or the authentication ceremony timed out", "NotAllowedError");
    if (t.name === "SecurityError") {
      const s = window.location.hostname;
      if (ne(s)) {
        if (r.rpId !== s)
          return new g(`The RP ID "${r.rpId}" is invalid for this domain`, "SecurityError");
      } else
        return new g(`${window.location.hostname} is an invalid domain`, "SecurityError");
    } else if (t.name === "UnknownError")
      return new g("The authenticator was unable to process the specified options, or could not create a new assertion signature", "UnknownError");
  }
  return t;
}
async function Oe(t, e = !1) {
  var n, r;
  if (!ee())
    throw new Error("WebAuthn is not supported in this browser");
  let s;
  ((n = t.allowCredentials) === null || n === void 0 ? void 0 : n.length) !== 0 && (s = (r = t.allowCredentials) === null || r === void 0 ? void 0 : r.map(re));
  const i = {
    ...t,
    challenge: j(t.challenge),
    allowCredentials: s
  }, c = {};
  if (e) {
    if (!await Re())
      throw Error("Browser does not support WebAuthn autofill");
    if (document.querySelectorAll("input[autocomplete*='webauthn']").length < 1)
      throw Error('No <input> with `"webauthn"` in its `autocomplete` attribute was detected');
    c.mediation = "conditional", i.allowCredentials = [];
  }
  c.publicKey = i, c.signal = K.createNewAbortSignal();
  let d;
  try {
    d = await navigator.credentials.get(c);
  } catch (l) {
    throw Pe({ error: l, options: c });
  } finally {
    K.reset();
  }
  if (!d)
    throw new Error("Authentication was not completed");
  const { id: f, rawId: h, response: a, type: o } = d;
  let u;
  return a.userHandle && (u = _e(a.userHandle)), {
    id: f,
    rawId: _(h),
    response: {
      authenticatorData: _(a.authenticatorData),
      clientDataJSON: _(a.clientDataJSON),
      signature: _(a.signature),
      userHandle: u
    },
    type: o,
    clientExtensionResults: d.getClientExtensionResults(),
    authenticatorAttachment: d.authenticatorAttachment
  };
}
const V = typeof window != "undefined", M = /* @__PURE__ */ new Map(), be = (t) => {
  var e;
  return V && typeof localStorage != "undefined" ? localStorage.getItem(t) : (e = M.get(t)) != null ? e : null;
}, Ce = (t, e) => {
  V && typeof localStorage != "undefined" ? e ? localStorage.setItem(t, e) : localStorage.removeItem(t) : e ? M.set(t, e) : M.has(t) && M.delete(t);
}, Ne = (t, e) => {
  if (t === "localStorage" || t === "web")
    return be;
  if (t === "cookie")
    return (n) => {
      var r;
      return V && (r = L.get(n)) != null ? r : null;
    };
  if (!e)
    throw Error(
      `clientStorageType is set to '${t}' but no clientStorage has been given`
    );
  if (t === "react-native")
    return (n) => {
      var r;
      return (r = e.getItem) == null ? void 0 : r.call(e, n);
    };
  if (t === "capacitor")
    return (n) => {
      var r;
      return (r = e.get) == null ? void 0 : r.call(e, { key: n });
    };
  if (t === "expo-secure-storage")
    return (n) => {
      var r;
      return (r = e.getItemAsync) == null ? void 0 : r.call(e, n);
    };
  if (t === "custom") {
    if (e.getItem && e.removeItem)
      return e.getItem;
    if (e.getItemAsync)
      return e.getItemAsync;
    throw Error(
      `clientStorageType is set to 'custom' but clientStorage is missing either "getItem" and "removeItem" properties or "getItemAsync" property`
    );
  }
  throw Error(`Unknown storage type: ${t}`);
}, xe = (t, e) => {
  if (t === "localStorage" || t === "web")
    return Ce;
  if (t === "cookie")
    return (n, r) => {
      V && (r ? L.set(n, r, { expires: 30, sameSite: "lax", httpOnly: !1 }) : L.remove(n));
    };
  if (!e)
    throw Error(
      `clientStorageType is set to '${t}' but no clienStorage has been given`
    );
  if (t === "react-native")
    return (n, r) => {
      var s, i;
      return r ? (s = e.setItem) == null ? void 0 : s.call(e, n, r) : (i = e.removeItem) == null ? void 0 : i.call(e, n);
    };
  if (t === "capacitor")
    return (n, r) => {
      var s, i;
      return r ? (s = e.set) == null ? void 0 : s.call(e, { key: n, value: r }) : (i = e.remove) == null ? void 0 : i.call(e, { key: n });
    };
  if (t === "expo-secure-storage")
    return async (n, r) => {
      var s, i;
      return r ? (s = e.setItemAsync) == null ? void 0 : s.call(e, n, r) : (i = e.deleteItemAsync) == null ? void 0 : i.call(e, n);
    };
  if (t === "custom") {
    if (!e.removeItem)
      throw Error(
        "clientStorageType is set to 'custom' but clientStorage is missing a removeItem property"
      );
    if (e.setItem)
      return (n, r) => {
        var s, i;
        return r ? (s = e.setItem) == null ? void 0 : s.call(e, n, r) : (i = e.removeItem) == null ? void 0 : i.call(e, n);
      };
    if (e.setItemAsync)
      return async (n, r) => {
        var s, i;
        return r ? (s = e.setItemAsync) == null ? void 0 : s.call(e, n, r) : (i = e.removeItem) == null ? void 0 : i.call(e, n);
      };
    throw Error(
      "clientStorageType is set to 'custom' but clientStorage is missing setItem or setItemAsync property"
    );
  }
  throw Error(`Unknown storage type: ${t}`);
}, x = (t) => !t || !t.accessToken.value || !t.accessToken.expiresAt || !t.user ? null : {
  accessToken: t.accessToken.value,
  accessTokenExpiresIn: (t.accessToken.expiresAt.getTime() - Date.now()) / 1e3,
  refreshToken: t.refreshToken.value,
  user: t.user
}, v = ({
  accessToken: t,
  refreshToken: e,
  isError: n,
  user: r,
  error: s
}) => n ? {
  session: null,
  error: s
} : r && t ? {
  // TODO either return the refresh token or remove it from the session type
  session: { accessToken: t, accessTokenExpiresIn: 0, refreshToken: e, user: r },
  error: null
} : { session: null, error: null }, q = () => typeof window != "undefined";
let se = globalThis.fetch;
typeof EdgeRuntime != "string" && (se = le().fetch);
const ie = async (t, e, { token: n, body: r } = {}) => {
  const s = {
    "Content-Type": "application/json",
    Accept: "*/*"
  };
  n && (s.Authorization = `Bearer ${n}`);
  const i = {
    method: e,
    headers: s
  };
  r && (i.body = JSON.stringify(r));
  try {
    const c = await se(t, i);
    if (!c.ok) {
      const d = await c.json();
      return Promise.reject({ error: d });
    }
    try {
      return { data: await c.json(), error: null };
    } catch {
      return console.warn(`Unexpected response: can't parse the response of the server at ${t}`), { data: "OK", error: null };
    }
  } catch {
    const d = {
      message: "Network Error",
      status: Z,
      error: "network"
    };
    return Promise.reject({ error: d });
  }
}, S = async (t, e, n) => ie(t, "POST", { token: n, body: e }), De = (t, e) => ie(t, "GET", { token: e }), oe = (t, e) => {
  const n = e && Object.entries(e).map(([r, s]) => {
    const i = Array.isArray(s) ? s.join(",") : typeof s == "object" ? JSON.stringify(s) : s;
    return `${r}=${encodeURIComponent(i)}`;
  }).join("&");
  return n ? `${t}?${n}` : t;
}, w = (t, e) => {
  if (!(e != null && e.redirectTo))
    return e;
  const { redirectTo: n, ...r } = e;
  if (!t)
    return n.startsWith("/") ? r : e;
  const s = new URL(t), i = Object.fromEntries(new URLSearchParams(s.search)), c = new URL(n.startsWith("/") ? s.origin + n : n), d = new URLSearchParams(c.search);
  let f = Object.fromEntries(d);
  n.startsWith("/") && (f = { ...i, ...f });
  let h = s.pathname;
  return c.pathname.length > 1 && (h += c.pathname.slice(1)), {
    ...r,
    redirectTo: oe(c.origin + h, f)
  };
};
function D(t, e) {
  var s;
  if (!e) {
    if (typeof window == "undefined")
      return;
    e = ((s = window.location) == null ? void 0 : s.href) || "";
  }
  t = t.replace(/[\[\]]/g, "\\$&");
  const n = new RegExp("[?&#]" + t + "(=([^&#]*)|&|#|$)"), r = n.exec(e);
  return r ? r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "" : null;
}
function F(t) {
  var n;
  if (typeof window == "undefined")
    return;
  const e = window == null ? void 0 : window.location;
  if (e && e) {
    const r = new URLSearchParams(e.search), s = new URLSearchParams((n = e.hash) == null ? void 0 : n.slice(1));
    r.delete(t), s.delete(t);
    let i = window.location.pathname;
    Array.from(r).length && (i += `?${r.toString()}`), Array.from(s).length && (i += `#${s.toString()}`), window.history.pushState({}, "", i);
  }
}
const I = (t) => !!t && typeof t == "string" && !!String(t).toLowerCase().match(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
), W = (t) => !!t && typeof t == "string" && t.length >= de, z = (t) => !!t && typeof t == "string", Ue = (t) => t && typeof t == "string" && t.match(/^mfaTotp:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i), Me = ({
  backendUrl: t,
  clientUrl: e,
  clientStorageType: n = "web",
  clientStorage: r,
  refreshIntervalTime: s,
  autoRefreshToken: i = !0,
  autoSignIn: c = !0
}) => {
  const d = Ne(n, r), f = xe(n, r), h = async (a, o, u) => (await S(`${t}${a}`, o, u)).data;
  return P(
    {
      schema: {
        context: {},
        events: {},
        services: {}
      },
      tsTypes: {},
      context: G,
      predictableActionArguments: !0,
      id: "nhost",
      type: "parallel",
      states: {
        authentication: {
          initial: "starting",
          on: {
            SESSION_UPDATE: [
              {
                cond: "hasSession",
                actions: ["saveSession", "resetTimer", "reportTokenChanged"],
                target: ".signedIn"
              }
            ]
          },
          states: {
            starting: {
              tags: ["loading"],
              always: { cond: "isSignedIn", target: "signedIn" },
              invoke: {
                id: "importRefreshToken",
                src: "importRefreshToken",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "signedIn"
                  },
                  {
                    target: "signedOut"
                  }
                ],
                onError: [
                  {
                    cond: "shouldRetryImportToken",
                    actions: "incrementTokenImportAttempts",
                    target: "retryTokenImport"
                  },
                  { actions: ["saveAuthenticationError"], target: "signedOut" }
                ]
              }
            },
            retryTokenImport: {
              tags: ["loading"],
              after: {
                RETRY_IMPORT_TOKEN_DELAY: "starting"
              }
            },
            signedOut: {
              initial: "noErrors",
              entry: "reportSignedOut",
              states: {
                noErrors: {},
                success: {},
                needsSmsOtp: {},
                needsMfa: {},
                failed: {},
                signingOut: {
                  entry: ["clearContextExceptRefreshToken"],
                  exit: ["destroyRefreshToken", "reportTokenChanged"],
                  invoke: {
                    src: "signout",
                    id: "signingOut",
                    onDone: {
                      target: "success"
                    },
                    onError: {
                      target: "failed",
                      actions: ["saveAuthenticationError"]
                    }
                  }
                }
              },
              on: {
                SIGNIN_PASSWORD: "authenticating.password",
                SIGNIN_ANONYMOUS: "authenticating.anonymous",
                SIGNIN_SECURITY_KEY_EMAIL: "authenticating.securityKeyEmail",
                SIGNIN_MFA_TOTP: "authenticating.mfa.totp",
                SIGNIN_PAT: "authenticating.pat"
              }
            },
            authenticating: {
              entry: "resetErrors",
              states: {
                password: {
                  invoke: {
                    src: "signInPassword",
                    id: "authenticateUserWithPassword",
                    onDone: [
                      {
                        cond: "hasMfaTicket",
                        actions: ["saveMfaTicket"],
                        target: "#nhost.authentication.signedOut.needsMfa"
                      },
                      {
                        actions: ["saveSession", "reportTokenChanged"],
                        target: "#nhost.authentication.signedIn"
                      }
                    ],
                    onError: [
                      {
                        cond: "unverified",
                        target: [
                          "#nhost.authentication.signedOut",
                          "#nhost.registration.incomplete.needsEmailVerification"
                        ]
                      },
                      {
                        actions: "saveAuthenticationError",
                        target: "#nhost.authentication.signedOut.failed"
                      }
                    ]
                  }
                },
                pat: {
                  invoke: {
                    src: "signInPAT",
                    id: "authenticateWithPAT",
                    onDone: {
                      actions: ["savePATSession", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    },
                    onError: {
                      actions: "saveAuthenticationError",
                      target: "#nhost.authentication.signedOut.failed"
                    }
                  }
                },
                anonymous: {
                  invoke: {
                    src: "signInAnonymous",
                    id: "authenticateAnonymously",
                    onDone: {
                      actions: ["saveSession", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    },
                    onError: {
                      actions: "saveAuthenticationError",
                      target: "#nhost.authentication.signedOut.failed"
                    }
                  }
                },
                mfa: {
                  states: {
                    totp: {
                      invoke: {
                        src: "signInMfaTotp",
                        id: "signInMfaTotp",
                        onDone: {
                          actions: ["saveSession", "reportTokenChanged"],
                          target: "#nhost.authentication.signedIn"
                        },
                        onError: {
                          actions: ["saveAuthenticationError"],
                          target: "#nhost.authentication.signedOut.failed"
                        }
                      }
                    }
                  }
                },
                securityKeyEmail: {
                  invoke: {
                    src: "signInSecurityKeyEmail",
                    id: "authenticateUserWithSecurityKey",
                    onDone: {
                      actions: ["saveSession", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    },
                    onError: [
                      {
                        cond: "unverified",
                        target: [
                          "#nhost.authentication.signedOut",
                          "#nhost.registration.incomplete.needsEmailVerification"
                        ]
                      },
                      {
                        actions: "saveAuthenticationError",
                        target: "#nhost.authentication.signedOut.failed"
                      }
                    ]
                  }
                }
              }
            },
            signedIn: {
              type: "parallel",
              entry: ["reportSignedIn", "cleanUrl", "broadcastToken", "resetErrors"],
              on: {
                SIGNOUT: "signedOut.signingOut"
              },
              states: {
                refreshTimer: {
                  id: "timer",
                  initial: "idle",
                  states: {
                    disabled: { type: "final" },
                    stopped: {
                      always: {
                        cond: "noToken",
                        target: "idle"
                      }
                    },
                    idle: {
                      always: [
                        { cond: "isAutoRefreshDisabled", target: "disabled" },
                        { cond: "isRefreshTokenPAT", target: "disabled" },
                        { cond: "hasRefreshToken", target: "running" }
                      ]
                    },
                    running: {
                      initial: "pending",
                      entry: "resetTimer",
                      states: {
                        pending: {
                          after: {
                            1e3: {
                              internal: !1,
                              target: "pending"
                            }
                          },
                          always: {
                            cond: "refreshTimerShouldRefresh",
                            target: "refreshing"
                          }
                        },
                        refreshing: {
                          invoke: {
                            src: "refreshToken",
                            id: "refreshToken",
                            onDone: {
                              actions: ["saveSession", "resetTimer", "reportTokenChanged"],
                              target: "pending"
                            },
                            onError: [{ actions: "saveRefreshAttempt", target: "pending" }]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },
        token: {
          initial: "idle",
          states: {
            idle: {
              on: {
                TRY_TOKEN: "running"
              },
              initial: "noErrors",
              states: { noErrors: {}, error: {} }
            },
            running: {
              invoke: {
                src: "refreshToken",
                id: "authenticateWithToken",
                onDone: {
                  actions: ["saveSession", "reportTokenChanged"],
                  target: ["#nhost.authentication.signedIn", "idle.noErrors"]
                },
                onError: [
                  { cond: "isSignedIn", target: "idle.error" },
                  {
                    actions: "saveAuthenticationError",
                    target: ["#nhost.authentication.signedOut.failed", "idle.error"]
                  }
                ]
              }
            }
          }
        },
        registration: {
          initial: "incomplete",
          on: {
            SIGNED_IN: [{ cond: "isAnonymous", target: ".incomplete" }, ".complete"]
          },
          states: {
            incomplete: {
              on: {
                SIGNUP_EMAIL_PASSWORD: "emailPassword",
                SIGNUP_SECURITY_KEY: "securityKey",
                PASSWORDLESS_EMAIL: "passwordlessEmail",
                PASSWORDLESS_SMS: "passwordlessSms",
                PASSWORDLESS_SMS_OTP: "passwordlessSmsOtp"
              },
              initial: "noErrors",
              states: {
                noErrors: {},
                needsEmailVerification: {},
                needsOtp: {},
                failed: {}
              }
            },
            emailPassword: {
              entry: ["resetErrors"],
              invoke: {
                src: "signUpEmailPassword",
                id: "signUpEmailPassword",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "#nhost.authentication.signedIn"
                  },
                  {
                    actions: "clearContext",
                    target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                  }
                ],
                onError: [
                  {
                    cond: "unverified",
                    target: "incomplete.needsEmailVerification"
                  },
                  {
                    actions: "saveRegistrationError",
                    target: "incomplete.failed"
                  }
                ]
              }
            },
            securityKey: {
              entry: ["resetErrors"],
              invoke: {
                src: "signUpSecurityKey",
                id: "signUpSecurityKey",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "#nhost.authentication.signedIn"
                  },
                  {
                    actions: "clearContext",
                    target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                  }
                ],
                onError: [
                  {
                    cond: "unverified",
                    target: "incomplete.needsEmailVerification"
                  },
                  {
                    actions: "saveRegistrationError",
                    target: "incomplete.failed"
                  }
                ]
              }
            },
            passwordlessEmail: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessEmail",
                id: "passwordlessEmail",
                onDone: {
                  actions: "clearContext",
                  target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            passwordlessSms: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessSms",
                id: "passwordlessSms",
                onDone: {
                  actions: "clearContext",
                  target: ["#nhost.authentication.signedOut", "incomplete.needsOtp"]
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            passwordlessSmsOtp: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessSmsOtp",
                id: "passwordlessSmsOtp",
                onDone: {
                  actions: ["saveSession", "reportTokenChanged"],
                  target: "#nhost.authentication.signedIn"
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            complete: {
              on: {
                SIGNED_OUT: "incomplete"
              }
            }
          }
        }
      }
    },
    {
      actions: {
        reportSignedIn: T("SIGNED_IN"),
        reportSignedOut: T("SIGNED_OUT"),
        reportTokenChanged: T("TOKEN_CHANGED"),
        incrementTokenImportAttempts: E({
          importTokenAttempts: ({ importTokenAttempts: a }) => a + 1
        }),
        clearContext: E(() => (f(R, null), f(O, null), f(N, null), {
          ...G
        })),
        clearContextExceptRefreshToken: E(({ refreshToken: { value: a } }) => (f(R, null), {
          ...G,
          refreshToken: { value: a }
        })),
        // * Save session in the context, and persist the refresh token and the jwt expiration outside of the machine
        saveSession: E({
          user: (a, { data: o }) => {
            var u;
            return ((u = o == null ? void 0 : o.session) == null ? void 0 : u.user) || null;
          },
          accessToken: (a, { data: o }) => {
            if (o.session) {
              const { accessTokenExpiresIn: u, accessToken: l } = o.session, m = new Date(Date.now() + u * 1e3);
              return f(R, m.toISOString()), {
                value: l,
                expiresAt: m,
                expiresInSeconds: u
              };
            }
            return f(R, null), {
              value: null,
              expiresAt: null,
              expiresInSeconds: null
            };
          },
          refreshToken: (a, { data: o }) => {
            var m, p;
            const u = ((m = o.session) == null ? void 0 : m.refreshToken) || null, l = ((p = o.session) == null ? void 0 : p.refreshTokenId) || null;
            return u && f(O, u), l && f(N, l), { value: u };
          }
        }),
        savePATSession: E({
          user: (a, { data: o }) => {
            var u;
            return ((u = o == null ? void 0 : o.session) == null ? void 0 : u.user) || null;
          },
          accessToken: (a, { data: o }) => {
            if (o.session) {
              const { accessTokenExpiresIn: u, accessToken: l } = o.session, m = new Date(Date.now() + u * 1e3);
              return f(R, m.toISOString()), {
                value: l,
                expiresAt: m,
                expiresInSeconds: u
              };
            }
            return f(R, null), {
              value: null,
              expiresAt: null,
              expiresInSeconds: null
            };
          },
          refreshToken: (a, { data: o }) => {
            var m, p;
            const u = ((m = o.session) == null ? void 0 : m.refreshToken) || null, l = ((p = o.session) == null ? void 0 : p.refreshTokenId) || null;
            return u && f(O, u), l && f(N, l), { value: u, isPAT: !0 };
          }
        }),
        saveMfaTicket: E({
          mfa: (a, o) => {
            var u;
            return (u = o.data) == null ? void 0 : u.mfa;
          }
        }),
        resetTimer: E({
          refreshTimer: (a) => ({
            startedAt: /* @__PURE__ */ new Date(),
            attempts: 0,
            lastAttempt: null
          })
        }),
        saveRefreshAttempt: E({
          refreshTimer: (a, o) => ({
            startedAt: a.refreshTimer.startedAt,
            attempts: a.refreshTimer.attempts + 1,
            lastAttempt: /* @__PURE__ */ new Date()
          })
        }),
        // * Authentication errors
        saveAuthenticationError: E({
          // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
          errors: ({ errors: a }, { data: { error: o } }) => ({
            ...a,
            authentication: o
          })
        }),
        resetErrors: E({
          errors: (a) => ({}),
          importTokenAttempts: (a) => 0
        }),
        saveRegistrationError: E({
          // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
          errors: ({ errors: a }, { data: { error: o } }) => ({ ...a, registration: o })
        }),
        destroyRefreshToken: E({
          refreshToken: (a) => (f(O, null), f(N, null), { value: null })
        }),
        // * Clean the browser url when `autoSignIn` is activated
        cleanUrl: () => {
          c && D("refreshToken") && (F("refreshToken"), F("type"));
        },
        // * Broadcast the token to other tabs when `autoSignIn` is activated
        broadcastToken: (a) => {
          if (c)
            try {
              new BroadcastChannel("nhost").postMessage(a.refreshToken.value);
            } catch {
            }
        }
      },
      guards: {
        isAnonymous: (a, o) => {
          var u;
          return !!((u = a.user) != null && u.isAnonymous);
        },
        isSignedIn: (a) => !!a.user && !!a.accessToken.value,
        noToken: (a) => !a.refreshToken.value,
        isRefreshTokenPAT: (a) => {
          var o;
          return !!((o = a.refreshToken) != null && o.isPAT);
        },
        hasRefreshToken: (a) => !!a.refreshToken.value,
        isAutoRefreshDisabled: () => !i,
        refreshTimerShouldRefresh: (a) => {
          const { expiresAt: o } = a.accessToken;
          if (!o)
            return !1;
          if (a.refreshTimer.lastAttempt)
            return a.refreshTimer.attempts > H ? !1 : Date.now() - a.refreshTimer.lastAttempt.getTime() > Math.pow(2, a.refreshTimer.attempts - 1) * 5e3;
          if (s && Date.now() - a.refreshTimer.startedAt.getTime() > s * 1e3)
            return !0;
          const u = a.accessToken.expiresInSeconds;
          return u ? o.getTime() - Date.now() - 1e3 * Math.min(fe, u * 0.5) <= 0 : !1;
        },
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        /** Shoud retry to import the token on network error or any internal server error.
         * Don't retry more than REFRESH_TOKEN_MAX_ATTEMPTS times.
         */
        shouldRetryImportToken: (a, o) => a.importTokenAttempts < H && (o.data.error.status === Z || o.data.error.status >= 500),
        // * Authentication errors
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        unverified: (a, { data: { error: o } }) => o.status === 401 && // * legacy: don't use the message contents to determine if the email is unverified, but the error type (error.error)
        (o.message === "Email is not verified" || o.error === "unverified-user"),
        // * Event guards
        hasSession: (a, o) => {
          var u;
          return !!((u = o.data) != null && u.session);
        },
        hasMfaTicket: (a, o) => {
          var u;
          return !!((u = o.data) != null && u.mfa);
        }
      },
      services: {
        signInPassword: (a, { email: o, password: u }) => I(o) ? W(u) ? h("/signin/email-password", {
          email: o,
          password: u
        }) : Promise.reject({ error: $ }) : Promise.reject({ error: A }),
        signInPAT: (a, { pat: o }) => h("/signin/pat", {
          personalAccessToken: o
        }),
        passwordlessSms: (a, { phoneNumber: o, options: u }) => {
          var l;
          return z(o) ? (l = a.user) != null && l.isAnonymous ? (console.warn(
            "Deanonymisation from a phone number is not yet implemented in hasura-auth"
          ), h(
            "/user/deanonymize",
            {
              signInMethod: "passwordless",
              connection: "sms",
              phoneNumber: o,
              options: w(e, u)
            },
            a.accessToken.value
          )) : h("/signin/passwordless/sms", {
            phoneNumber: o,
            options: w(e, u)
          }) : Promise.reject({ error: Y });
        },
        passwordlessSmsOtp: (a, { phoneNumber: o, otp: u }) => z(o) ? h("/signin/passwordless/sms/otp", {
          phoneNumber: o,
          otp: u
        }) : Promise.reject({ error: Y }),
        passwordlessEmail: (a, { email: o, options: u }) => {
          var l;
          return I(o) ? (l = a.user) != null && l.isAnonymous ? h(
            "/user/deanonymize",
            {
              signInMethod: "passwordless",
              connection: "email",
              email: o,
              options: w(e, u)
            },
            a.accessToken.value
          ) : h("/signin/passwordless/email", {
            email: o,
            options: w(e, u)
          }) : Promise.reject({ error: A });
        },
        signInAnonymous: (a) => h("/signin/anonymous"),
        signInMfaTotp: (a, o) => {
          var l;
          const u = o.ticket || ((l = a.mfa) == null ? void 0 : l.ticket);
          return u ? Ue(u) ? h("/signin/mfa/totp", {
            ticket: u,
            otp: o.otp
          }) : Promise.reject({ error: Ee }) : Promise.reject({ error: ge });
        },
        signInSecurityKeyEmail: async (a, { email: o }) => {
          if (!I(o))
            throw new U(A);
          const u = await h(
            "/signin/webauthn",
            { email: o }
          );
          let l;
          try {
            l = await Oe(u);
          } catch (m) {
            throw new U(m);
          }
          return h("/signin/webauthn/verify", { email: o, credential: l });
        },
        refreshToken: async (a, o) => {
          const u = o.type === "TRY_TOKEN" ? o.token : a.refreshToken.value;
          return { session: await h("/token", {
            refreshToken: u
          }), error: null };
        },
        signout: (a, o) => h("/signout", {
          refreshToken: a.refreshToken.value,
          all: !!o.all
        }),
        signUpEmailPassword: async (a, { email: o, password: u, options: l }) => {
          var m;
          return I(o) ? W(u) ? (m = a.user) != null && m.isAnonymous ? h(
            "/user/deanonymize",
            {
              signInMethod: "email-password",
              email: o,
              password: u,
              options: w(e, l)
            },
            a.accessToken.value
          ) : h("/signup/email-password", {
            email: o,
            password: u,
            options: w(e, l)
          }) : Promise.reject({ error: $ }) : Promise.reject({ error: A });
        },
        signUpSecurityKey: async (a, { email: o, options: u }) => {
          if (!I(o))
            return Promise.reject({ error: A });
          const l = u == null ? void 0 : u.nickname;
          l && delete u.nickname;
          const m = await h(
            "/signup/webauthn",
            { email: o, options: u }
          );
          let p;
          try {
            p = await te(m);
          } catch (ce) {
            throw new U(ce);
          }
          return h("/signup/webauthn/verify", {
            credential: p,
            options: {
              redirectTo: u == null ? void 0 : u.redirectTo,
              nickname: l
            }
          });
        },
        importRefreshToken: async (a) => {
          if (a.user && a.refreshToken.value && a.accessToken.value && a.accessToken.expiresAt)
            return {
              session: {
                accessToken: a.accessToken.value,
                accessTokenExpiresIn: a.accessToken.expiresAt.getTime() - Date.now(),
                refreshToken: a.refreshToken.value,
                user: a.user
              },
              error: null
            };
          let o = null;
          if (c) {
            const l = D("refreshToken") || null;
            if (l)
              try {
                return { session: await h("/token", {
                  refreshToken: l
                }), error: null };
              } catch (m) {
                o = m.error;
              }
            else {
              const m = D("error");
              if (m)
                return Promise.reject({
                  session: null,
                  error: {
                    status: k,
                    error: m,
                    message: D("errorDescription") || m
                  }
                });
            }
          }
          const u = await d(O);
          if (u)
            try {
              return { session: await h("/token", {
                refreshToken: u
              }), error: null };
            } catch (l) {
              o = l.error;
            }
          return o ? Promise.reject({ error: o, session: null }) : { error: null, session: null };
        }
      },
      delays: {
        RETRY_IMPORT_TOKEN_DELAY: ({ importTokenAttempts: a }) => Math.pow(2, a - 1) * 5e3
      }
    }
  );
}, Ke = ({ backendUrl: t, clientUrl: e, interpreter: n }) => P(
  {
    schema: {
      context: {},
      events: {},
      services: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "changeEmail",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidEmail",
              actions: "saveInvalidEmailError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidEmailError: E({ error: (r) => A }),
      saveRequestError: E({
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        error: (r, { data: { error: s } }) => s
      }),
      reportError: T((r) => ({ type: "ERROR", error: r.error })),
      // TODO change email in the main machine (context.user.email)
      reportSuccess: T("SUCCESS")
    },
    guards: {
      invalidEmail: (r, { email: s }) => !I(s)
    },
    services: {
      requestChange: async (r, { email: s, options: i }) => (await S(
        `${t}/user/email/change`,
        { newEmail: s, options: w(e, i) },
        n == null ? void 0 : n.getSnapshot().context.accessToken.value
      )).data
    }
  }
), Ve = ({ backendUrl: t, interpreter: e }) => P(
  {
    schema: {
      context: {},
      events: {},
      services: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "changePassword",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidPassword",
              actions: "saveInvalidPasswordError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidPasswordError: E({ error: (n) => $ }),
      saveRequestError: E({
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        error: (n, { data: { error: r } }) => r
      }),
      reportError: T((n) => ({ type: "ERROR", error: n.error })),
      reportSuccess: T("SUCCESS")
    },
    guards: {
      invalidPassword: (n, { password: r }) => !W(r)
    },
    services: {
      requestChange: (n, { password: r, ticket: s }) => S(
        `${t}/user/password`,
        { newPassword: r, ticket: s },
        e == null ? void 0 : e.getSnapshot().context.accessToken.value
      )
    }
  }
), ar = ({ backendUrl: t, interpreter: e }) => P(
  {
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "enableMfa",
    initial: "idle",
    context: { error: null, imageUrl: null, secret: null },
    states: {
      idle: {
        initial: "initial",
        on: {
          GENERATE: "generating"
        },
        states: {
          initial: {},
          error: {}
        }
      },
      generating: {
        invoke: {
          src: "generate",
          id: "generate",
          onDone: { target: "generated", actions: ["reportGeneratedSuccess", "saveGeneration"] },
          onError: { actions: ["saveError", "reportGeneratedError"], target: "idle.error" }
        }
      },
      generated: {
        initial: "idle",
        states: {
          idle: {
            initial: "idle",
            on: {
              ACTIVATE: [
                {
                  cond: "invalidMfaType",
                  actions: "saveInvalidMfaTypeError",
                  target: ".error"
                },
                {
                  cond: "invalidMfaCode",
                  actions: "saveInvalidMfaCodeError",
                  target: ".error"
                },
                {
                  target: "activating"
                }
              ]
            },
            states: { idle: {}, error: {} }
          },
          activating: {
            invoke: {
              src: "activate",
              id: "activate",
              onDone: { target: "activated", actions: "reportSuccess" },
              onError: { actions: ["saveError", "reportError"], target: "idle.error" }
            }
          },
          activated: { type: "final" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidMfaTypeError: E({ error: (n) => he }),
      saveInvalidMfaCodeError: E({ error: (n) => me }),
      saveError: E({
        error: (n, { data: { error: r } }) => r
      }),
      saveGeneration: E({
        imageUrl: (n, { data: { imageUrl: r } }) => r,
        secret: (n, { data: { totpSecret: r } }) => r
      }),
      reportError: T((n, r) => (console.log("REPORT", n, r), { type: "ERROR", error: n.error })),
      reportSuccess: T("SUCCESS"),
      reportGeneratedSuccess: T("GENERATED"),
      reportGeneratedError: T((n) => ({ type: "GENERATED_ERROR", error: n.error }))
    },
    guards: {
      invalidMfaCode: (n, { code: r }) => !r,
      invalidMfaType: (n, { activeMfaType: r }) => !r || r !== "totp"
    },
    services: {
      generate: async (n) => {
        const { data: r } = await De(
          `${t}/mfa/totp/generate`,
          e == null ? void 0 : e.getSnapshot().context.accessToken.value
        );
        return r;
      },
      activate: (n, { code: r, activeMfaType: s }) => S(
        `${t}/user/mfa`,
        { code: r, activeMfaType: s },
        e == null ? void 0 : e.getSnapshot().context.accessToken.value
      )
    }
  }
), Ge = ({ backendUrl: t, clientUrl: e }) => P(
  {
    schema: {
      context: {},
      events: {},
      services: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "changePassword",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidEmail",
              actions: "saveInvalidEmailError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidEmailError: E({ error: (n) => A }),
      saveRequestError: E({
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        error: (n, { data: { error: r } }) => r
      }),
      reportError: T((n) => ({ type: "ERROR", error: n.error })),
      reportSuccess: T("SUCCESS")
    },
    guards: {
      invalidEmail: (n, { email: r }) => !I(r)
    },
    services: {
      requestChange: (n, { email: r, options: s }) => S(`${t}/user/password/reset`, {
        email: r,
        options: w(e, s)
      })
    }
  }
), Le = ({ backendUrl: t, clientUrl: e }) => P(
  {
    schema: {
      context: {},
      events: {},
      services: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "sendVerificationEmail",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidEmail",
              actions: "saveInvalidEmailError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "request",
          id: "request",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidEmailError: E({ error: (n) => A }),
      saveRequestError: E({
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        error: (n, { data: { error: r } }) => r
      }),
      reportError: T((n) => ({ type: "ERROR", error: n.error })),
      reportSuccess: T("SUCCESS")
    },
    guards: {
      invalidEmail: (n, { email: r }) => !I(r)
    },
    services: {
      request: async (n, { email: r, options: s }) => (await S(
        `${t}/user/email/send-verification-email`,
        { email: r, options: w(e, s) }
      )).data
    }
  }
);
class ae {
  constructor({
    clientStorageType: e = "web",
    autoSignIn: n = !0,
    autoRefreshToken: r = !0,
    start: s = !0,
    backendUrl: i,
    clientUrl: c,
    devTools: d,
    ...f
  }) {
    if (this._started = !1, this._subscriptionsQueue = /* @__PURE__ */ new Set(), this._subscriptions = /* @__PURE__ */ new Set(), this.backendUrl = i, this.clientUrl = c, this._machine = Me({
      ...f,
      backendUrl: i,
      clientUrl: c,
      clientStorageType: e,
      autoSignIn: n,
      autoRefreshToken: r
    }), s && this.start({ devTools: d }), typeof window != "undefined" && n)
      try {
        this._channel = new BroadcastChannel("nhost"), this._channel.addEventListener("message", (h) => {
          var o;
          const a = (o = this.interpreter) == null ? void 0 : o.getSnapshot().context.refreshToken.value;
          this.interpreter && h.data !== a && this.interpreter.send("TRY_TOKEN", { token: h.data });
        });
      } catch {
      }
  }
  start({
    devTools: e = !1,
    initialSession: n,
    interpreter: r
  } = {}) {
    var c, d;
    const s = { ...this.machine.context };
    n && (s.user = n.user, s.refreshToken.value = (c = n.refreshToken) != null ? c : null, s.accessToken.value = (d = n.accessToken) != null ? d : null, s.accessToken.expiresAt = new Date(
      Date.now() + n.accessTokenExpiresIn * 1e3
    ));
    const i = this.machine.withContext(s);
    this._interpreter || (this._interpreter = r || b(i, { devTools: e })), (!this._started || typeof window == "undefined") && (this._interpreter.initialized && (this._interpreter.stop(), this._subscriptions.forEach((f) => f())), this._interpreter.start(i.initialState), this._subscriptionsQueue.forEach((f) => f(this))), this._started = !0;
  }
  get machine() {
    return this._machine;
  }
  get interpreter() {
    return this._interpreter;
  }
  get started() {
    return this._started;
  }
  subscribe(e) {
    if (this.started) {
      const n = e(this);
      return this._subscriptions.add(n), n;
    } else
      return this._subscriptionsQueue.add(e), () => {
        console.log(
          "onTokenChanged was added before the interpreter started. Cannot unsubscribe listener."
        );
      };
  }
}
class $e extends ae {
  constructor({
    ...e
  }) {
    super({
      ...e,
      autoSignIn: q() && e.autoSignIn,
      autoRefreshToken: q() && e.autoRefreshToken,
      clientStorageType: "cookie"
    });
  }
}
const cr = $e, qe = async ({ backendUrl: t, interpreter: e }, n) => {
  try {
    const { data: r } = await S(
      `${t}/user/webauthn/add`,
      {},
      e == null ? void 0 : e.getSnapshot().context.accessToken.value
    );
    let s;
    try {
      s = await te(r);
    } catch (c) {
      throw new U(c);
    }
    const { data: i } = await S(
      `${t}/user/webauthn/verify`,
      { credential: s, nickname: n },
      e == null ? void 0 : e.getSnapshot().context.accessToken.value
    );
    return { key: i, isError: !1, error: null, isSuccess: !0 };
  } catch (r) {
    const { error: s } = r;
    return { isError: !0, error: s, isSuccess: !1 };
  }
}, We = async (t, e, n) => new Promise((r) => {
  t.send("REQUEST", {
    email: e,
    options: n
  }), t.onTransition((s) => {
    s.matches({ idle: "error" }) ? r({ error: s.context.error, isError: !0, needsEmailVerification: !1 }) : s.matches({ idle: "success" }) && r({ error: null, isError: !1, needsEmailVerification: !0 });
  });
}), je = async (t, e, n) => new Promise((r) => {
  t.send("REQUEST", {
    password: e,
    ticket: n
  }), t.onTransition((s) => {
    s.matches({ idle: "error" }) ? r({ error: s.context.error, isError: !0, isSuccess: !1 }) : s.matches({ idle: "success" }) && r({ error: null, isError: !1, isSuccess: !0 });
  });
}), ur = (t) => new Promise((e) => {
  t.send("GENERATE"), t.onTransition((n) => {
    n.matches("generated") ? e({
      error: null,
      isError: !1,
      isGenerated: !0,
      qrCodeDataUrl: n.context.imageUrl || ""
    }) : n.matches({ idle: "error" }) && e({
      error: n.context.error || null,
      isError: !0,
      isGenerated: !1,
      qrCodeDataUrl: ""
    });
  });
}), lr = (t, e) => new Promise((n) => {
  t.send("ACTIVATE", {
    activeMfaType: "totp",
    code: e
  }), t.onTransition((r) => {
    r.matches({ generated: "activated" }) ? n({ error: null, isActivated: !0, isError: !1 }) : r.matches({ generated: { idle: "error" } }) && n({ error: r.context.error, isActivated: !1, isError: !0 });
  });
}), He = async (t, e, n) => new Promise((r) => {
  t.send("REQUEST", {
    email: e,
    options: n
  }), t.onTransition((s) => {
    s.matches({ idle: "error" }) ? r({ error: s.context.error, isError: !0, isSent: !1 }) : s.matches({ idle: "success" }) && r({ error: null, isError: !1, isSent: !0 });
  });
}), Ye = (t, e, n) => new Promise((r) => {
  t.send("REQUEST", {
    email: e,
    options: n
  }), t.onTransition((s) => {
    s.matches({ idle: "error" }) ? r({ error: s.context.error, isError: !0, isSent: !1 }) : s.matches({ idle: "success" }) && r({ error: null, isError: !1, isSent: !0 });
  });
}), Fe = (t) => new Promise((e) => {
  const { changed: n } = t.send("SIGNIN_ANONYMOUS");
  n || e({
    isSuccess: !1,
    isError: !0,
    error: y,
    user: null,
    accessToken: null,
    refreshToken: null
  }), t.onTransition((r) => {
    r.matches({ authentication: "signedIn" }) && e({
      isSuccess: !0,
      isError: !1,
      error: null,
      user: r.context.user,
      accessToken: r.context.accessToken.value,
      refreshToken: r.context.refreshToken.value
    }), r.matches({ authentication: { signedOut: "failed" } }) && e({
      isSuccess: !1,
      isError: !0,
      error: r.context.errors.authentication || null,
      user: null,
      accessToken: null,
      refreshToken: null
    });
  });
}), ze = (t, e, n) => new Promise((r) => {
  const { changed: s, context: i } = t.send("SIGNIN_PASSWORD", {
    email: e,
    password: n
  });
  if (!s)
    return r({
      accessToken: i.accessToken.value,
      refreshToken: i.refreshToken.value,
      error: y,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: i.user
    });
  t.onTransition((c) => {
    c.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? r({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      needsMfaOtp: !1,
      mfa: null,
      user: null
    }) : c.matches({ authentication: { signedOut: "needsMfa" } }) ? r({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !0,
      mfa: c.context.mfa,
      user: null
    }) : c.matches({ authentication: { signedOut: "failed" } }) ? r({
      accessToken: null,
      refreshToken: null,
      error: c.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: null
    }) : c.matches({ authentication: "signedIn" }) && r({
      accessToken: c.context.accessToken.value,
      refreshToken: c.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: c.context.user
    });
  });
}), Q = (t, e, n) => new Promise((r) => {
  const { changed: s } = t.send("PASSWORDLESS_EMAIL", {
    email: e,
    options: n
  });
  if (!s)
    return r({
      error: y,
      isError: !0,
      isSuccess: !1
    });
  t.onTransition((i) => {
    i.matches("registration.incomplete.failed") ? r({
      error: i.context.errors.registration || null,
      isError: !0,
      isSuccess: !1
    }) : i.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) && r({ error: null, isError: !1, isSuccess: !0 });
  });
}), Qe = (t, e) => new Promise((n) => {
  const { changed: r, context: s } = t.send({ type: "SIGNIN_SECURITY_KEY_EMAIL", email: e });
  if (!r)
    return n({
      accessToken: s.accessToken.value,
      refreshToken: s.refreshToken.value,
      error: y,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: s.user
    });
  t.onTransition((i) => {
    i.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? n({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : i.matches({ authentication: { signedOut: "failed" } }) ? n({
      accessToken: null,
      refreshToken: null,
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : i.matches({ authentication: "signedIn" }) && n({
      accessToken: i.context.accessToken.value,
      refreshToken: i.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: i.context.user
    });
  });
}), Be = (t, e, n) => new Promise((r) => {
  const { changed: s, context: i } = t.send("SIGNIN_MFA_TOTP", {
    otp: e,
    ticket: n
  });
  if (!s)
    return r({
      accessToken: i.accessToken.value,
      refreshToken: i.refreshToken.value,
      error: y,
      isError: !0,
      isSuccess: !1,
      user: i.user
    });
  t.onTransition((c) => {
    c.matches({ authentication: { signedOut: "failed" } }) ? r({
      accessToken: null,
      refreshToken: null,
      error: c.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      user: null
    }) : c.matches({ authentication: "signedIn" }) && r({
      accessToken: c.context.accessToken.value,
      refreshToken: c.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      user: c.context.user
    });
  });
}), Xe = (t, e) => new Promise((n) => {
  const { changed: r } = t.send("SIGNIN_PAT", { pat: e });
  r || n({
    isSuccess: !1,
    isError: !0,
    error: y,
    user: null,
    accessToken: null,
    refreshToken: null
  }), t.onTransition((s) => {
    if (s.matches({ authentication: { signedOut: "failed" } }))
      return n({
        accessToken: null,
        refreshToken: null,
        user: null,
        error: s.context.errors.authentication || null,
        isError: !0,
        isSuccess: !1
      });
    if (s.matches({ authentication: "signedIn" }))
      return n({
        accessToken: s.context.accessToken.value,
        refreshToken: s.context.refreshToken.value,
        user: s.context.user,
        error: null,
        isError: !1,
        isSuccess: !0
      });
  });
}), B = (t, e, n) => new Promise((r) => {
  const { changed: s } = t.send("PASSWORDLESS_SMS", { phoneNumber: e, options: n });
  if (!s)
    return r({
      error: y,
      isError: !0,
      isSuccess: !1,
      needsOtp: !1
    });
  t.onTransition((i) => {
    i.matches("registration.incomplete.needsOtp") ? r({
      error: null,
      isError: !1,
      isSuccess: !1,
      needsOtp: !0
    }) : i.matches("registration.incomplete.failed") && r({
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsOtp: !1
    });
  });
}), Ze = (t, e, n) => new Promise((r) => {
  const { changed: s } = t.send({ type: "PASSWORDLESS_SMS_OTP", phoneNumber: e, otp: n });
  if (!s)
    return r({
      error: y,
      isError: !0,
      isSuccess: !1,
      user: null,
      accessToken: null,
      refreshToken: null
    });
  t.onTransition((i) => {
    i.matches({ authentication: "signedIn" }) ? r({
      error: null,
      isError: !1,
      isSuccess: !0,
      user: i.context.user,
      accessToken: i.context.accessToken.value,
      refreshToken: i.context.refreshToken.value
    }) : i.matches({ registration: { incomplete: "failed" } }) && r({
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      user: null,
      accessToken: null,
      refreshToken: null
    });
  });
}), Je = async (t, e) => new Promise((n) => {
  const { event: r } = t.send("SIGNOUT", { all: e });
  if (r.type !== "SIGNED_OUT")
    return n({ isSuccess: !1, isError: !0, error: we });
  t.onTransition((s) => {
    s.matches({ authentication: { signedOut: "success" } }) ? n({ isSuccess: !0, isError: !1, error: null }) : s.matches("authentication.signedOut.failed") && n({ isSuccess: !1, isError: !0, error: s.context.errors.signout || null });
  });
}), X = (t, e, n, r) => new Promise((s) => {
  const { changed: i, context: c } = t.send("SIGNUP_EMAIL_PASSWORD", {
    email: e,
    password: n,
    options: r
  });
  if (!i)
    return s({
      error: y,
      accessToken: c.accessToken.value,
      refreshToken: c.refreshToken.value,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: c.user
    });
  t.onTransition((d) => {
    d.matches("registration.incomplete.failed") ? s({
      accessToken: null,
      refreshToken: null,
      error: d.context.errors.registration || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : d.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? s({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : d.matches({ authentication: "signedIn", registration: "complete" }) && s({
      accessToken: d.context.accessToken.value,
      refreshToken: d.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: d.context.user
    });
  });
}), er = (t, e, n) => new Promise((r) => {
  const { changed: s, context: i } = t.send("SIGNUP_SECURITY_KEY", {
    email: e,
    options: n
  });
  if (!s)
    return r({
      error: y,
      accessToken: i.accessToken.value,
      refreshToken: i.refreshToken.value,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: i.user
    });
  t.onTransition((c) => {
    c.matches("registration.incomplete.failed") ? r({
      accessToken: null,
      refreshToken: null,
      error: c.context.errors.registration || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : c.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? r({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : c.matches({ authentication: "signedIn", registration: "complete" }) && r({
      accessToken: c.context.accessToken.value,
      refreshToken: c.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: c.context.user
    });
  });
}), rr = async ({ backendUrl: t, interpreter: e }, { expiresAt: n, metadata: r }) => {
  try {
    const { data: s } = await S(
      `${t}/pat`,
      { expiresAt: n.toUTCString(), metadata: r },
      e == null ? void 0 : e.getSnapshot().context.accessToken.value
    );
    return {
      data: s ? {
        id: s.id || null,
        personalAccessToken: s.personalAccessToken || null
      } : null,
      isError: !1,
      error: null,
      isSuccess: !0
    };
  } catch (s) {
    const { error: i } = s;
    return { isError: !0, error: i, isSuccess: !1, data: null };
  }
};
class dr {
  constructor({
    url: e,
    autoRefreshToken: n = !0,
    autoSignIn: r = !0,
    clientStorage: s,
    clientStorageType: i,
    refreshIntervalTime: c,
    start: d = !0
  }) {
    var f;
    this.url = e, this._client = new ae({
      backendUrl: e,
      clientUrl: typeof window != "undefined" && ((f = window.location) == null ? void 0 : f.origin) || "",
      autoRefreshToken: n,
      autoSignIn: r,
      start: d,
      clientStorage: s,
      clientStorageType: i,
      refreshIntervalTime: c
    });
  }
  /**
   * Use `nhost.auth.signUp` to sign up a user using email and password. If you want to sign up a user using passwordless email (Magic Link), SMS, or an OAuth provider, use the `signIn` function instead.
   *
   * @example
   * ### Sign up with an email and password
   * ```ts
   * nhost.auth.signUp({
   *   email: 'joe@example.com',
   *   password: 'secret-password'
   * })
   * ```
   *
   * @example
   * ### Sign up with a security key
   * ```ts
   * nhost.auth.signUp({
   *   email: 'joe@example.com',
   *   securityKey: true
   * })
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/sign-up
   */
  async signUp(e) {
    const n = await this.waitUntilReady(), { email: r, options: s } = e;
    return "securityKey" in e ? v(
      await er(n, r, s)
    ) : v(
      await X(n, r, e.password, s)
    );
  }
  /**
   * Use `nhost.auth.signIn` to sign in a user using email and password, passwordless (email or sms) or an external provider. `signIn` can be used to sign in a user in various ways depending on the parameters.
   *
   * @example
   * ### Sign in a user using email and password
   * ```ts
   * nhost.auth.signIn({
   *   email: 'joe@example.com',
   *   password: 'secret-password'
   * })
   * ```
   *
   * @example
   * ### Sign in a user using an OAuth provider (e.g: Google or Facebook)
   * ```ts
   * nhost.auth.signIn({ provider: 'google' })
   * ```
   *
   * @example
   * ### Sign in a user using passwordless email (Magic Link)
   * ```ts
   * nhost.auth.signIn({ email: 'joe@example.com' })
   * ```
   *
   * @example
   * ### Sign in a user using passwordless SMS
   * ```ts
   * // [step 1/2] Passwordless sign in using SMS
   * nhost.auth.signIn({ phoneNumber: '+11233213123' })
   *
   * // [step 2/2] Finish passwordless sign in using SMS (OTP)
   * nhost.auth.signIn({ phoneNumber: '+11233213123', otp: '123456' })
   * ```
   *
   * @example
   * ### Sign in anonymously
   * ```ts
   * // Sign in anonymously
   * nhost.auth.signIn()
   *
   * // Later in the application, the user can complete their registration
   * nhost.auth.signUp({
   *   email: 'joe@example.com',
   *   password: 'secret-password'
   * })
   * ```
   *
   * @example
   * ### Sign in with a security key
   * ```ts
   * nhost.auth.signIn({
   *   email: 'joe@example.com',
   *   securityKey: true
   * })
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/sign-in
   */
  async signIn(e) {
    const n = await this.waitUntilReady();
    if (!e) {
      const r = await Fe(n);
      return { ...v(r), mfa: null };
    }
    if ("provider" in e) {
      const { provider: r, options: s } = e, i = oe(
        `${this._client.backendUrl}/signin/provider/${r}`,
        w(this._client.clientUrl, s)
      );
      return q() && (window.location.href = i), { providerUrl: i, provider: r, session: null, mfa: null, error: null };
    }
    if ("email" in e && "password" in e) {
      const r = await ze(n, e.email, e.password);
      return r.needsEmailVerification ? { session: null, mfa: null, error: ke } : r.needsMfaOtp ? {
        session: null,
        mfa: r.mfa,
        error: null
      } : { ...v(r), mfa: null };
    }
    if ("email" in e && "securityKey" in e) {
      if (e.securityKey !== !0)
        throw Error("securityKey must be true");
      const r = await Qe(n, e.email);
      return { ...v(r), mfa: null };
    }
    if ("email" in e) {
      const { email: r, options: s } = e, { error: i } = await Q(n, r, s);
      return {
        session: null,
        mfa: null,
        error: i
      };
    }
    if ("phoneNumber" in e && "otp" in e) {
      const r = await Ze(n, e.phoneNumber, e.otp);
      return { ...v(r), mfa: null };
    }
    if ("phoneNumber" in e) {
      const { error: r } = await B(
        n,
        e.phoneNumber,
        e.options
      );
      return { error: r, mfa: null, session: null };
    }
    if ("otp" in e) {
      const r = await Be(n, e.otp, e.ticket);
      return { ...v(r), mfa: null };
    }
    return { error: Se, mfa: null, session: null };
  }
  /**
   * Use `nhost.auth.signInPAT` to sign in with a personal access token (PAT).
   *
   * @example
   * ```ts
   * nhost.auth.signInPAT('34f74930-09c0-4af5-a8d5-28fad78e3415')
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/sign-in-pat
   *
   * @param personalAccessToken - The personal access token to sign in with
   */
  async signInPAT(e) {
    const n = await this.waitUntilReady(), r = await Xe(n, e);
    return v(r);
  }
  /**
   * Use `nhost.auth.signOut` to sign out the user.
   *
   * @example
   * ### Sign out the user from current device
   * ```ts
   * nhost.auth.signOut()
   * ```
   *
   * @example
   * ### Sign out the user from all devices
   * ```ts
   * nhost.auth.signOut({all: true})
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/sign-out
   */
  async signOut(e) {
    const n = await this.waitUntilReady(), { error: r } = await Je(n, e == null ? void 0 : e.all);
    return { error: r };
  }
  /**
   * Use `nhost.auth.resetPassword` to reset the password for a user. This will send a reset-password link in an email to the user. When the user clicks the reset-password link the user is automatically signed-in. Once signed-in, the user can change their password using `nhost.auth.changePassword()`.
   *
   * @example
   * ```ts
   * nhost.auth.resetPassword({email: 'joe@example.com' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/reset-password
   */
  async resetPassword({ email: e, options: n }) {
    const r = b(Ge(this._client)).start(), { error: s } = await He(r, e, n);
    return { error: s };
  }
  /**
   * Use `nhost.auth.changePassword` to change the password for the signed-in user. The old password is not needed. In case the user is not signed-in, a password reset ticket needs to be provided.
   *
   * @example
   * ```ts
   * nhost.auth.changePassword({ newPassword: 'new-secret-password' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/change-password
   */
  async changePassword({
    newPassword: e,
    ticket: n
  }) {
    const r = b(Ve(this._client)).start(), { error: s } = await je(r, e, n);
    return { error: s };
  }
  /**
   * Use `nhost.auth.sendVerificationEmail` to send a verification email to the specified email. The email contains a verification-email link. When the user clicks the verification-email link their email is verified.
   *
   * @example
   * ```ts
   * nhost.auth.sendVerificationEmail({ email: 'joe@example.com' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/send-verification-email
   */
  async sendVerificationEmail({
    email: e,
    options: n
  }) {
    const r = b(Le(this._client)).start(), { error: s } = await Ye(r, e, n);
    return { error: s };
  }
  /**
   * Use `nhost.auth.changeEmail` to change a user's email. This will send a confirm-email-change link in an email to the new email. Once the user clicks on the confirm-email-change link the email will be change to the new email.
   *
   * @example
   * ```ts
   * nhost.auth.changeEmail({ newEmail: 'doe@example.com' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/change-email
   */
  async changeEmail({ newEmail: e, options: n }) {
    const r = b(Ke(this._client)).start(), { error: s } = await We(r, e, n);
    return { error: s };
  }
  /**
   * Use `nhost.auth.deanonymize` to deanonymize a user.
   *
   * @example
   * ```ts
   * nhost.auth.deanonymize({signInMethod: 'email-password', email: 'joe@example.com' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/deanonymize
   */
  async deanonymize(e) {
    const n = await this.waitUntilReady();
    if (e.signInMethod === "passwordless") {
      if (e.connection === "email") {
        const { error: r } = await Q(
          n,
          e.email,
          e.options
        );
        return { error: r };
      }
      if (e.connection === "sms") {
        const { error: r } = await B(
          n,
          e.phoneNumber,
          e.options
        );
        return { error: r };
      }
    }
    if (e.signInMethod === "email-password") {
      const { error: r } = await X(
        n,
        e.email,
        e.password,
        e.options
      );
      return { error: r };
    }
    throw Error("Unknown deanonymization method");
  }
  /**
   * Use `nhost.auth.addSecurityKey to add a security key to the user, using the WebAuthn API.
   * @param nickname optional human-readable nickname for the security key
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/add-security-key
   */
  async addSecurityKey(e) {
    const { error: n, key: r } = await qe(this._client, e);
    return { error: n, key: r };
  }
  /**
   * Use `nhost.auth.createPAT` to create a personal access token for the user.
   *
   * @param expiresAt Expiration date for the token
   * @param metadata Optional metadata to store with the token
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/create-pat
   */
  async createPAT(e, n) {
    return rr(this._client, { expiresAt: e, metadata: n });
  }
  /**
   * Use `nhost.auth.onTokenChanged` to add a custom function that runs every time the access or refresh token is changed.
   *
   *
   * @example
   * ```ts
   * nhost.auth.onTokenChanged(() => console.log('The access and refresh token has changed'));
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/on-token-changed
   */
  onTokenChanged(e) {
    return this._client.subscribe(() => {
      var r;
      const n = (r = this._client.interpreter) == null ? void 0 : r.onTransition(({ event: s, context: i }) => {
        s.type === "TOKEN_CHANGED" && e(x(i));
      });
      return () => n == null ? void 0 : n.stop();
    });
  }
  /**
   * Use `nhost.auth.onAuthStateChanged` to add a custom function that runs every time the authentication status of the user changes. E.g. add a custom function that runs every time the authentication status changes from signed-in to signed-out.
   *
   * @example
   * ```ts
   * nhost.auth.onAuthStateChanged((event, session) => {
   *   console.log(`The auth state has changed. State is now ${event} with session: ${session}`)
   * });
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/on-auth-state-changed
   */
  onAuthStateChanged(e) {
    return this._client.subscribe(() => {
      var r;
      const n = (r = this._client.interpreter) == null ? void 0 : r.onTransition(({ event: s, context: i }) => {
        (s.type === "SIGNED_IN" || s.type === "SIGNED_OUT") && e(s.type, x(i));
      });
      return () => n == null ? void 0 : n.stop();
    });
  }
  /**
   * Use `nhost.auth.isAuthenticated` to check if the user is authenticated or not.
   *
   * Note: `nhost.auth.isAuthenticated()` can return `false` for two reasons:
   * 1. The user is not authenticated
   * 2. The user is not authenticated but _might_ be authenticated soon (loading) because there is a network request in transit.
   *
   * Use `nhost.auth.getAuthenticationStatus` to get both authentication and loading status.
   *
   * @example
   * ```ts
   * const isAuthenticated = nhost.auth.isAuthenticated();
   *
   * if (isAuthenticated) {
   *   console.log('User is authenticated');
   * }
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/is-authenticated
   */
  isAuthenticated() {
    var e;
    return !!((e = this._client.interpreter) != null && e.getSnapshot().matches({ authentication: "signedIn" }));
  }
  /**
   * Use `nhost.auth.isAuthenticatedAsync` to wait (await) for any internal authentication network requests to finish and then return the authentication status.
   *
   * The promise won't resolve until the authentication status is known.
   * Attention: when using auto-signin and a refresh token is present in the client storage, the promise won't resolve if the server can't be reached (e.g. offline) or if it returns an internal error.
   *
   * @example
   * ```ts
   * const isAuthenticated  = await nhost.auth.isAuthenticatedAsync();
   *
   * if (isAuthenticated) {
   *   console.log('User is authenticated');
   * }
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/is-authenticated-async
   */
  async isAuthenticatedAsync() {
    return (await this.waitUntilReady()).getSnapshot().matches({ authentication: "signedIn" });
  }
  /**
   * Use `nhost.auth.getAuthenticationStatus` to get the authentication status of the user.
   *
   * If `isLoading` is `true`, the client doesn't know whether the user is authenticated yet or not
   * because some internal authentication network requests have not been resolved yet.
   *
   * The `connectionAttempts` returns the number of times the client has tried to connect to the server with no success (offline, or the server retruned an internal error).
   *
   * @example
   * ```ts
   * const { isAuthenticated, isLoading } = nhost.auth.getAuthenticationStatus();
   *
   * if (isLoading) {
   *   console.log('Loading...')
   * }
   *
   * if (isAuthenticated) {
   *   console.log('User is authenticated');
   * }
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-authentication-status
   */
  getAuthenticationStatus() {
    var n;
    const e = ((n = this.client.interpreter) == null ? void 0 : n.getSnapshot().context.importTokenAttempts) || 0;
    return this.isReady() ? { isAuthenticated: this.isAuthenticated(), isLoading: !1, connectionAttempts: e } : {
      isAuthenticated: !1,
      isLoading: !0,
      connectionAttempts: e
    };
  }
  /**
   * Use `nhost.auth.getAccessToken` to get the access token of the user.
   *
   * @example
   * ```ts
   * const accessToken = nhost.auth.getAccessToken();
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-access-token
   */
  getAccessToken() {
    var e, n;
    return (n = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot().context.accessToken.value) != null ? n : void 0;
  }
  /**
   * Use `nhost.auth.getDecodedAccessToken` to get the decoded access token of the user.
   *
   * @example
   * ```ts
   * const decodedAccessToken = nhost.auth.getDecodedAccessToken();
   * ```
   *
   * @see {@link https://hasura.io/docs/latest/graphql/core/auth/authentication/jwt/| Hasura documentation}
   * @docs https://docs.nhost.io/reference/javascript/auth/get-decoded-access-token
   */
  getDecodedAccessToken() {
    const e = this.getAccessToken();
    return e ? ue(e) : null;
  }
  /**
   * Use `nhost.auth.getHasuraClaims` to get the Hasura claims of the user.
   *
   * @example
   * ```ts
   * const hasuraClaims = nhost.auth.getHasuraClaims();
   * ```
   *
   * @see {@link https://hasura.io/docs/latest/graphql/core/auth/authentication/jwt/| Hasura documentation}
   * @docs https://docs.nhost.io/reference/javascript/auth/get-hasura-claims
   */
  getHasuraClaims() {
    var e;
    return ((e = this.getDecodedAccessToken()) == null ? void 0 : e["https://hasura.io/jwt/claims"]) || null;
  }
  /**
   * Use `nhost.auth.getHasuraClaim` to get the value of a specific Hasura claim of the user.
   *
   * @example
   * ```ts
   * // if `x-hasura-company-id` exists as a custom claim
   * const companyId = nhost.auth.getHsauraClaim('company-id')
   * ```
   *
   * @param name Name of the variable. You don't have to specify `x-hasura-`.
   *
   * @see {@link https://hasura.io/docs/latest/graphql/core/auth/authentication/jwt/| Hasura documentation}
   * @docs https://docs.nhost.io/reference/javascript/auth/get-hasura-claim
   */
  getHasuraClaim(e) {
    var n;
    return ((n = this.getHasuraClaims()) == null ? void 0 : n[e.startsWith("x-hasura-") ? e : `x-hasura-${e}`]) || null;
  }
  /**
   *
   * Use `nhost.auth.refreshSession` to refresh the session with either the current internal refresh token or an external refresh token.
   *
   * Note: The Nhost client automatically refreshes the session when the user is authenticated but `nhost.auth.refreshSession` can be useful in some special cases.
   *
   * @example
   * ```ts
   * // Refresh the session with the the current internal refresh token.
   * nhost.auth.refreshToken();
   *
   * // Refresh the session with an external refresh token.
   * nhost.auth.refreshToken(refreshToken);
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/refresh-session
   */
  async refreshSession(e) {
    try {
      const n = await this.waitUntilReady();
      return new Promise((r) => {
        const s = e || n.getSnapshot().context.refreshToken.value;
        if (!s)
          return r({ session: null, error: Te });
        const { changed: i } = n.send("TRY_TOKEN", { token: s });
        if (!i)
          return r({ session: null, error: pe });
        n.onTransition((c) => {
          c.matches({ token: { idle: "error" } }) ? r({
            session: null,
            // * TODO get the error from xstate once it is implemented
            error: ye
          }) : c.event.type === "TOKEN_CHANGED" && r({ session: x(c.context), error: null });
        });
      });
    } catch (n) {
      return { session: null, error: n.message };
    }
  }
  /**
   *
   * Use `nhost.auth.getSession()` to get the session of the user.
   *
   * @example
   * ```ts
   * const session = nhost.auth.getSession();
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-session
   */
  getSession() {
    var e, n;
    return x((n = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) == null ? void 0 : n.context);
  }
  /**
   *
   * Use `nhost.auth.getUser()` to get the signed-in user.
   *
   * @example
   * ```ts
   * const user = nhost.auth.getUser();
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-user
   */
  getUser() {
    var e, n, r;
    return ((r = (n = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) == null ? void 0 : n.context) == null ? void 0 : r.user) || null;
  }
  /**
   * Make sure the state machine is set, and wait for it to be ready
   * @returns
   */
  waitUntilReady() {
    const n = this._client.interpreter;
    if (!n)
      throw Error("Auth interpreter not set");
    return n.getSnapshot().hasTag("loading") ? new Promise((r, s) => {
      let i = setTimeout(
        () => s("The state machine is not yet ready after 15 seconds."),
        15e3
      );
      n.onTransition((c) => {
        if (!c.hasTag("loading"))
          return clearTimeout(i), r(n);
      });
    }) : Promise.resolve(n);
  }
  isReady() {
    var e, n;
    return !((n = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) != null && n.hasTag("loading"));
  }
  get client() {
    return this._client;
  }
}
export {
  ae as AuthClient,
  cr as AuthClientSSR,
  $e as AuthCookieClient,
  U as CodifiedError,
  ke as EMAIL_NEEDS_VERIFICATION,
  dr as HasuraAuthClient,
  G as INITIAL_MACHINE_CONTEXT,
  A as INVALID_EMAIL_ERROR,
  me as INVALID_MFA_CODE_ERROR,
  Ee as INVALID_MFA_TICKET_ERROR,
  he as INVALID_MFA_TYPE_ERROR,
  $ as INVALID_PASSWORD_ERROR,
  Y as INVALID_PHONE_NUMBER_ERROR,
  ye as INVALID_REFRESH_TOKEN,
  Se as INVALID_SIGN_IN_METHOD,
  de as MIN_PASSWORD_LENGTH,
  Z as NETWORK_ERROR_CODE,
  R as NHOST_JWT_EXPIRES_AT_KEY,
  N as NHOST_REFRESH_TOKEN_ID_KEY,
  O as NHOST_REFRESH_TOKEN_KEY,
  ge as NO_MFA_TICKET_ERROR,
  Te as NO_REFRESH_TOKEN,
  J as OTHER_ERROR_CODE,
  H as REFRESH_TOKEN_MAX_ATTEMPTS,
  C as STATE_ERROR_CODE,
  pe as TOKEN_REFRESHER_RUNNING_ERROR,
  fe as TOKEN_REFRESH_MARGIN_SECONDS,
  y as USER_ALREADY_SIGNED_IN,
  or as USER_NOT_ANONYMOUS,
  we as USER_UNAUTHENTICATED,
  k as VALIDATION_ERROR_CODE,
  lr as activateMfaPromise,
  qe as addSecurityKeyPromise,
  We as changeEmailPromise,
  je as changePasswordPromise,
  Me as createAuthMachine,
  Ke as createChangeEmailMachine,
  Ve as createChangePasswordMachine,
  ar as createEnableMfaMachine,
  Ge as createResetPasswordMachine,
  Le as createSendVerificationEmailMachine,
  oe as encodeQueryParameters,
  ur as generateQrCodePromise,
  v as getAuthenticationResult,
  De as getFetch,
  D as getParameterByName,
  x as getSession,
  q as isBrowser,
  I as isValidEmail,
  W as isValidPassword,
  z as isValidPhoneNumber,
  Ue as isValidTicket,
  Ne as localStorageGetter,
  xe as localStorageSetter,
  S as postFetch,
  F as removeParameterFromWindow,
  He as resetPasswordPromise,
  w as rewriteRedirectTo,
  Ye as sendVerificationEmailPromise,
  Fe as signInAnonymousPromise,
  ze as signInEmailPasswordPromise,
  Q as signInEmailPasswordlessPromise,
  Qe as signInEmailSecurityKeyPromise,
  Be as signInMfaTotpPromise,
  Xe as signInPATPromise,
  Ze as signInSmsPasswordlessOtpPromise,
  B as signInSmsPasswordlessPromise,
  Je as signOutPromise,
  X as signUpEmailPasswordPromise,
  er as signUpEmailSecurityKeyPromise
};
//# sourceMappingURL=index.esm.js.map
